import { useResizeViewport } from "../../hooks/useResizeViewport";
import { useEventHandler } from "../../hooks/useEventHandler";
export const MapHandler = () => {
    useResizeViewport();
    useEventHandler();
    return null;
};
